module.exports = __webpack_public_path__ + "media/images/icons/logo_missing-439468ce829f1ae487d96b2d933f119a.svg";